import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FixTransactionBetService } from 'src/app/apis/fix-transaction-bet.service';
import { MemberService } from 'src/app/apis/member.service';
import { ReportWinloseService } from 'src/app/apis/report-winlose.service';
import { AppCore } from 'src/app/utils/classes/app-core';
import { alertConfirm, alertSuccess } from 'src/app/utils/functions/alert';
import md5 from 'md5';
@Component({
  selector: 'app-winlose-detail-casino',
  templateUrl: './winlose-detail-casino.component.html',
  styleUrls: ['./winlose-detail-casino.component.scss'],
})
export class WinloseDetailCasinoComponent extends AppCore implements OnInit {
  @Input() betId: string;
  @Input() gameType: string;
  @Output() BackTo = new EventEmitter<boolean>();
  loadingWinlose = false;
  data: any[];
  dataTemp: any[];
  tnxtId: string;

  summary = {
    amount: 0,
    wl: 0,
    bonus: 0,
  };

  url: any;
  activeBetReplay: any;
  betReplayType: 'url' | 'json' | '' = 'url';
  betReplayGame: 'baccarat' | 'dragon-tiger' | 'roulette' | 'sicbo' | '' = '';

  BacarratResult: IBacarrat;
  DragonTigerResult: IDragonTiger;
  RouletteResult: IRoulette;
  loadingResult = false;
  allStatus = true;
  constructor(
    private ngActRoute: ActivatedRoute,
    private svReportWinlose: ReportWinloseService,
    private sanitizer: DomSanitizer,
    private svFix: FixTransactionBetService,
  ) {
    super();
  }
  ngOnInit() {
    this.getBetDetail();
    console.log(this.betId, this.gameType);
  }
  onBackToWinLoseDetail() {
    this.svReportWinlose.$onBackFromDetail.next();
  }
  getBetDetail() {
    this.summary.amount = 0;
    this.summary.wl = 0;
    this.summary.bonus = 0;

    this.loadingWinlose = true;
    this.svReportWinlose.getWinloseDetailCasino(this.betId).subscribe(
      (res: any[]) => {
        // sort by txnId
        if (res && res.length > 0) {
          if (res[0].product_id != 'BETGAME') {
            const sortFn = (a, b) => {
              const aStrNum = a.txnId.split('-')[1];
              const bStrNum = b.txnId.split('-')[1];
              return bStrNum - aStrNum;
            };

            res = res.sort(sortFn);
          }

          this.dataTemp = res;
          this.data = res;
          this.data.forEach((element) => {
            if (
              element.status === 'WIN' ||
              element.status === 'LOSE' ||
              element.status === 'DRAW'
            ) {
              this.summary.amount += element.betAmount;
              this.summary.wl += element.winloseAmount || 0;
            }
            if (element.status === 'BONUS') {
              this.summary.bonus += element.winloseAmount;
            }
          });
        } else {
          this.dataTemp = [];
          this.data = [];
          this.summary.amount = 0;
          this.summary.wl = 0;
          this.summary.bonus = 0;
        }
        this.loadingWinlose = false;
      },
      (err) => {
        this.loadingWinlose = false;
      },
    );
  }

  filterStatus() {
    if (this.allStatus) {
      this.data = this.dataTemp;
    } else {
      this.data = this.dataTemp.filter(
        (c) =>
          c.status === 'WIN' ||
          c.status === 'LOSE' ||
          c.status === 'RUNNING' ||
          c.status === 'BONUS',
      );
    }
  }

  fixMakeBetCancel(data: any) {
    alertConfirm({ html: `คุณต้องการยกเลิก TXNID : <b>${data.txnId}</b> หรือไม่?` }).then((c) => {
      if (c.isConfirmed) {
        this.svFix
          .makeCannelBet({
            game_type: this.gameType,
            username: data.username,
            betId: data.betId,
            txnId: data.txnId,
            roundId: data.roundId,
          })
          .subscribe(() => {
            alertSuccess({ message: 'cancel bet success ' + data.txnId });
            this.getBetDetail();
          });
      }
    });
  }

  getReplay(data: any) {
    this.loadingResult = true;
    this.url = '';
    this.activeBetReplay = data;
    let user = data.username;
    if (data.userId_sexy) {
      user = data.userId_sexy;
    }
    this.svReportWinlose
      .getBetReplay({
        productId: data.product_id,
        txnId_or_betId: data.txnId,
        username: user,
        roundId_or_parentBetId: data.roundId,
        gameCode: data.game_code,
        currency: this.currentAgent.currency,
        version_v2: false,
      })
      .subscribe(
        (res: any) => {
          if (!res.data) {
            this.betReplayGame = '';
            this.betReplayType = '';
            this.loadingResult = false;
            return;
          }
          if ((res.data?.url as string).startsWith('http')) {
            this.betReplayType = 'url';
            this.url = this.sanitizer.bypassSecurityTrustResourceUrl(res.data.url);
          } else if ((res.data?.url as string) !== '') {
            this.betReplayType = 'json';
            const jsonReplay = JSON.parse(res.data.url);
            // roulette
            if (jsonReplay?.betResult?.p) {
              this.betReplayGame = 'roulette';
              const r = this.roulette(jsonReplay?.betResult?.p);
              this.RouletteResult = {
                textColor: r.color,
                textNumber: r.text,
              };
            }
            // dragon tiger
            if (jsonReplay?.betResult?.dragon) {
              this.betReplayGame = 'dragon-tiger';
              const result = jsonReplay?.betResult;
              this.DragonTigerResult = {
                Dragon: [],
                Tiger: [],
                DragonPoint: 0,
                TigerPoint: 0,
              };

              if (/[0-9]/g.exec(result.dragon.r) || /A/g.exec(result?.dragon.r)) {
                result.dragon.r = result.dragon.r === 'A' ? '1' : result.dragon.r;
                this.DragonTigerResult.DragonPoint += +result.dragon.r;
                this.DragonTigerResult.Dragon.push({
                  r: result.dragon.r,
                  s: result.dragon.s,
                });
              }

              if (/[0-9]/g.exec(result.tiger.r) || /A/g.exec(result?.tiger.r)) {
                result.tiger.r = result.tiger.r === 'A' ? '1' : result.tiger.r;
                this.DragonTigerResult.TigerPoint += +result.tiger.r;
                this.DragonTigerResult.Tiger.push({
                  r: result.tiger.r,
                  s: result.tiger.s,
                });
              }
            }

            // barcarrat
            if (jsonReplay?.betResult?.player) {
              this.betReplayGame = 'baccarat';
              this.BacarratResult = {
                Banker: [],
                Player: [],
                PlayerPoint: 0,
                BankerPoint: 0,
              };

              let player = 0;
              jsonReplay?.betResult?.player.forEach((element) => {
                if (element.r && element.s) {
                  if (/[0-9]/g.exec(element.r) || /A/g.exec(element.r)) {
                    element.r = element.r === 'A' ? '1' : element.r;
                    player += +element.r;
                  }
                  this.BacarratResult.Player.push({
                    r: element.r,
                    s: element.s,
                  });
                }
              });

              let banker = 0;
              jsonReplay.betResult?.banker.forEach((element) => {
                if (element.r && element.s) {
                  if (/[0-9]/g.exec(element.r) || /A/g.exec(element.r)) {
                    element.r = element.r === 'A' ? '1' : element.r;
                    banker += +element.r;
                  }
                  this.BacarratResult.Banker.push({
                    r: element.r,
                    s: element.s,
                  });
                }
              });

              this.BacarratResult.PlayerPoint = player % 10;
              this.BacarratResult.BankerPoint = banker % 10;
            }
            if (jsonReplay?.detail) {
              if (
                (jsonReplay?.detail as string).startsWith('Banker') ||
                (jsonReplay?.detail as string).startsWith('Player')
              ) {
                this.betReplayGame = 'baccarat';
                this.BacarratResult = {
                  Banker: [],
                  Player: [],
                  PlayerPoint: 0,
                  BankerPoint: 0,
                };

                let playerPoint = 0;
                let bankerPoint = 0;
                // {"detail":"Banker:♦A♠10 Player:♥A♣7","playInfo":"Banker"}
                const banker = jsonReplay?.detail.split(' ')[0].split(':')[1].split('') as string; // "['♦','A','♠','10']"
                this.BacarratResult.Banker.push({
                  s: this.emojiToText(banker[0]),
                  r: this.textNumber(banker[1]),
                });
                this.BacarratResult.Banker.push({
                  s: this.emojiToText(banker[2]),
                  r: this.textNumber(banker[3]),
                });

                if (banker.length === 6) {
                  this.BacarratResult.Banker.push({
                    s: this.emojiToText(banker[4]),
                    r: this.textNumber(banker[5]),
                  });
                }

                this.BacarratResult.Banker.forEach((element) => {
                  if (/[0-9]/g.exec(element.r)) {
                    bankerPoint += +element.r;
                  }
                });

                const player = jsonReplay?.detail.split(' ')[1].split(':')[1].split('') as string; // "['♥','A','♣','7']"

                this.BacarratResult.Player.push({
                  s: this.emojiToText(player[0]),
                  r: this.textNumber(player[1]),
                });
                this.BacarratResult.Player.push({
                  s: this.emojiToText(player[2]),
                  r: this.textNumber(player[3]),
                });

                if (player.length === 6) {
                  this.BacarratResult.Player.push({
                    s: this.emojiToText(player[4]),
                    r: this.textNumber(player[5]),
                  });
                }

                this.BacarratResult.Player.forEach((element) => {
                  if (/[0-9]/g.exec(element.r)) {
                    playerPoint += +element.r;
                  }
                });

                this.BacarratResult.PlayerPoint = playerPoint % 10;
                this.BacarratResult.BankerPoint = bankerPoint % 10;
              } else {
                this.betReplayGame = 'roulette';
                this.activeBetReplay.betType = jsonReplay?.playInfo;
                const r = this.roulette(jsonReplay?.detail);
                this.RouletteResult = {
                  textColor: r.color,
                  textNumber: r.text,
                };
              }
            }
          } else {
            this.betReplayGame = '';
            this.betReplayType = '';
          }
          this.loadingResult = false;
        },
        (err) => {
          this.loadingResult = false;
        },
      );
  }
  emojiToText(emoji: string) {
    if (emoji === '♠') {
      return 'C';
    } else if (emoji === '♦') {
      return 'D';
    } else if (emoji === '♥') {
      return 'H';
    } else if (emoji === '♣') {
      return 'S';
    }
  }
  textNumber(text: string) {
    if (/[0-9]/g.exec(text) || /A/g.exec(text)) {
      return text === 'A' ? '1' : text;
    } else {
      return text;
    }
  }
  roulette(Textnumber: string) {
    const red = '|1|3|5|7|9|12|14|16|18|19|21|23|25|27|30|32|34|36|';
    if (red.includes('|' + Textnumber + '|')) {
      return {
        text: Textnumber,
        color: 'red',
      };
    } else {
      return {
        text: Textnumber,
        color: 'black',
      };
    }
  }
  getColorRoundId(item: any) {
    var roundId = md5(item.roundId || '');
    var color = roundId.substring(roundId.length - 6, roundId.length);
    return color;
  }
}

export interface IBacarrat {
  Player: ICard[];
  Banker: ICard[];
  PlayerPoint: number;
  BankerPoint: number;
}
export interface IRoulette {
  textNumber: string;
  textColor: string;
}
export interface IDragonTiger {
  Dragon: ICard[];
  Tiger: ICard[];
  DragonPoint: number;
  TigerPoint: number;
}
export interface ICard {
  s: string;
  r: string;
}
